class NewsLetter {
  constructor() {
      this.$newsletter = document.querySelector('[data-newsletter]');
      if (this.$newsletter === null) {
          return; // Newsletter component not present
      }
      this.init();
    }

    init() {
        const
            inputEmail = this.$newsletter.querySelector('#mce-EMAIL'),
            buttonSubmit = this.$newsletter.querySelector('#mc-embedded-subscribe');

        if (inputEmail === null || buttonSubmit === null) {
            return; // required fields not found in document
        }

      const validateEmail = (email) => {
          return email.match(
              /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
      };

      const validate = () => {
          const email = inputEmail.value;

          if (validateEmail(email)) {
              buttonSubmit.removeClass('c-button--greyed')
              buttonSubmit.removeClass('c-button--border-greyed')
          } else {
              buttonSubmit.addClass('c-button--greyed')
              buttonSubmit.addClass('c-button--border-greyed')
          }
          return false;
      }

      inputEmail.addEventListener('input', validate);

  }

}

export default new NewsLetter();
